import axios from "../";
import { TParams } from "@/types/common";
import { IData } from "@/types/general";
import { project } from "@/constants/project";
import { TPageData } from "@/types/pageData";

export const pageData = {
  homePageData: (params: TParams) => {
    return axios.post("/v2", {
      project: project.lms,
      action: "landing_site_page_data_v2",
      query_params: params?.query_params,
      body: params?.body,
    });
  },
};
